<script>
export default {
	props: {
		children: Array,
		link: String,
		transparent: Boolean,
		hideIcons: Boolean,
		text: String,
		dense: Boolean,
		arrowColor: String,
		iconType: String,
		icon: String,
		iconHtml: String,
		iconImage: [Object, String],
	},
}
</script>

<template>
	<v-menu bottom open-on-hover offset-y :disabled="!children" class="px-0" attach="">
		<v-list :color="$vars.primary">
			<v-list-item class="" v-for="child of children" :key="child.id">
				<div>
					<SafeLink :to="child.link" class="w100">
						<v-list-item-title>
							<div v-html="child.name"></div>
						</v-list-item-title>
					</SafeLink>
				</div>
			</v-list-item>
		</v-list>
		<template #activator="{ on, attrs }">
			<SafeLink :to="link" class="d-inline-block h100 d-flex">
				<AppBar-Button
					class="primary"
					:transparent="transparent"
					:dense="dense"
					:text="text"
					:hide-icon="hideIcons"
					:icon-type="iconType"
					:icon="icon"
					:icon-html="iconHtml"
					:icon-image="iconImage"
					v-bind="attrs"
					v-on="on"
				>
					<template #bottom>
						<span v-if="children">
							<v-icon :color="arrowColor || $vars.primarytext"> mdi-chevron-down </v-icon>
						</span>
					</template>
				</AppBar-Button>
			</SafeLink>
		</template>
	</v-menu>
</template>

